<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    content: string;
    show?: boolean;
    mode?: "hover" | "fade";
  }>(),
  {
    show: false,
    mode: "hover",
  },
);
</script>

<template>
  <Transition name="tooltip-fade">
    <div v-if="props.show" class="tooltip">
      <small>{{ props.content }}</small>
    </div>
  </Transition>
</template>

<style lang="postcss" scoped>
.tooltip {
  position: absolute;
  background-color: var(--color-gray-500);
  color: var(--color-white);
  border-radius: 4px;
  padding: 0.1rem 0.5rem;
  display: flex;
  place-items: center;
  z-index: 1000;
  width: fit-content;
  white-space: nowrap;
}

.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.3s ease;
}

.tooltip-fade-enter-from,
.tooltip-fade-leave-to {
  opacity: 0;
}

.tooltip-fade-enter-to,
.tooltip-fade-leave-from {
  opacity: 1;
}
</style>
